import { z } from "zod";
export const patientFactConditionSchema = z.object({
  fact: z.literal("age"),
  operator: z.enum(["=", "!=", ">", "<", ">=", "<="]),
  value: z.number().int().nonnegative(),
});
